<app-navbar-style-two></app-navbar-style-two>

<section id="section-recipes" class="al_row al_Section recipes-section text-center text-white">
        <!-- =====================
     RECIPE BANNER
====================== -->
        <div class="recipe-banner">
            <div class="banner-right-content">
                <h1>UNIKAI Recipes</h1>
                <p>
                    Turn everyday meals into delicious creations with UNIKAI.
                    Quality ingredients for healthier, tastier recipes.
                </p>
            </div>
            
        </div>

        <!-- =====================
     FILTER SECTION
====================== -->
        <div class="recipe-filter container-fluid">
            <h3 class="filter-title">Filter By</h3>

            <div class="filter-row">
                <!-- Brand Dropdown (native select so options update when data loads) -->
                <select class="filter-select no-nice-select" [(ngModel)]="selectedBrand" (change)="filterRecipes()">
                    <option [ngValue]="null">All Brands</option>
                    <option *ngFor="let brand of brandList" [ngValue]="brand.id">
                        {{ brand.name }}
                    </option>
                </select>

                <!-- Meal Time Dropdown -->
                <select class="filter-select no-nice-select" [(ngModel)]="selectedMeal" (change)="filterRecipes()">
                    <option [ngValue]="null">Meal Time</option>
                    <option *ngFor="let meal of mealTimes" [ngValue]="meal.id">
                        {{ meal.name }}
                    </option>
                </select>
            </div>
        </div>


        <!-- LOADING -->
        <div class="text-center py-5" *ngIf="loading">
            <p>Loading recipes...</p>
        </div>

        <!-- NO DATA -->
        <div class="text-center py-5" *ngIf="!loading && recipes.length === 0">
            <p>No recipes available.</p>
        </div>

        <!-- CARDS GRID -->
        <div class="row mt-4 g-4 p-5 justify-content-center" *ngIf="!loading">

            <div class="col-md-3" *ngFor="let r of recipes">
                <div class="recipe-card-wrapper">

                    <!-- IMAGE -->
                    <div class="recipe-img">
                        <img [src]="getImg(r.t_image)" [alt]="r.title" loading="lazy" />
                    </div>

                    <!-- CARD -->
                    <div class="recipe-card">
                        <h5 class="mb-2">
                            {{ r.subtitle || r.title }}
                        </h5>

                        <p>{{ r.description }}</p>

                        <a class="btn btn-recipe mt-3" (click)="viewRecipe(r.slugs)">
                            Get recipe
                        </a>
                    </div>

                </div>
            </div>

        </div>


</section>

<section class="download-section">
    <div class="left">
      <h3>Download Brochure</h3>
      <p>Get detailed insights about our products and services</p>
    </div>
    <button class="primary-btn">Download Now</button>
  </section>
<app-footer-style-one></app-footer-style-one>